import { Navigate, createBrowserRouter } from 'react-router-dom'
import { ProtectedRoute } from './auth/ProtectedRoute'
import { AppShell } from './components/AppShell'
import { LoginPage } from './features/auth/LoginPage'
import { CatalogPage } from './features/catalogs/CatalogPage'
import { DashboardPage } from './features/tasks/DashboardPage'
import { TaskDetailPage } from './features/tasks/TaskDetailPage'
import { TaskForm } from './features/tasks/TaskForm'

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <AppShell />,
        children: [
          { index: true, element: <DashboardPage /> },
          { path: 'tarefas/nova', element: <TaskForm /> },
          { path: 'tarefas/:id', element: <TaskDetailPage /> },
          { path: 'tarefas/:id/editar', element: <TaskForm /> },
          { path: 'cadastros', element: <CatalogPage /> },
        ],
      },
    ],
  },
  { path: '*', element: <Navigate to="/" replace /> },
])
